import { flagKey } from './constants';

// Не используем существующие хуки, чтобы не ограничивать себя в контексте выполнения функции
export const getSearchParam = () => {
    try {
        const currentURL = new URL(window?.location?.href);
        // Извлекаем объект URLSearchParams
        const searchParams = currentURL.searchParams;

        return searchParams.get(flagKey);
    } catch (_e) {
        return null;
    }
};

export const setSearchParam = (value: string) => {
    try {
        // Получаем текущий URL
        const url = new URL(window?.location?.href);

        // Если значение параметра равно `null`, удаляем его
        if (value === '') {
            url.searchParams.delete(flagKey);
        } else {
            // Иначе обновляем или добавляем параметр
            url.searchParams.set(flagKey, value);
        }

        // Обновляем URL в истории браузера без перезагрузки страницы
        window.history.replaceState(null, '', url);
    } catch (_e) {
        return;
    }
};
